// import Vue from 'vue'
// import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: {
      name: "broadcast"
    }
  },
  {
    path: '/broadcast',
    name: 'broadcast',
    component: () => import('@/components/information/broadcast.vue'),
  },
  {
    path: '/financing',
    name: 'financing',
    component: () => import('@/components/information/financing.vue'),
  },
  {
    path: '/comments',
    name: 'comments',
    component: () => import('@/components/information/comments.vue'),
  },
  {
    path: '/drygoods',
    name: 'drygoods',
    component: () => import('@/components/information/drygoods.vue'),
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('@/components/information/project.vue'),
  },
  {
    path: '/evaluation',
    name: 'evaluation',
    component: () => import('@/components/research/evaluation.vue'),
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@/components/research/report.vue'),
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('@/components/research/list.vue'),
  },
  {
    path: '/industry',
    name: 'industry',
    component: () => import('@/components/data/industry.vue'),
  },
  {
    path: '/unicorn',
    name: 'unicorn',
    component: () => import('@/components/data/unicorn.vue'),
  },
  {
    path: '/horse',
    name: 'horse',
    component: () => import('@/components/data/horse.vue'),
  },
  {
    path: '/financeData',
    name: 'financeData',
    component: () => import('@/components/data/financeData.vue'),
  },
  {
    path: '/appstore',
    name: 'appstore',
    component: () => import('@/components/data/appstore.vue'),
  },
  {
    path: '/deathData',
    name: 'deathData',
    component: () => import('@/components/data/deathData.vue'),
  },
  {
    path: '/exposure',
    name: 'exposure',
    component: () => import('@/components/complaints/exposure.vue'),
  },
  {
    path: '/complainList',
    name: 'complainList',
    component: () => import('@/components/complaints/complainList.vue'),
  },
  {
    path: '/rating',
    name: 'rating',
    component: () => import('@/components/complaints/rating.vue'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
